/// <reference path="../../BaseNew/GBaseAdmImportData.ts"/>

namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class ImportAdmSpisovyZnak extends GContentBase {
        private importDataObj: ImportAdmSpisovyZnakObj & GContent;
        private metadata: Gordic.AdmIsl.Interface.GAdmSubjectMetaData
        private dataListDescription: Gordic.General.ApplicationInterface.GDataListDescription;

        onContentReady() {
            this.importDataObj = $.extend(this as GContent, new ImportAdmSpisovyZnakObj());
            this.importDataObj.createBase({
                title: "jres:33000649", //RC 33000649 : Hromadné načtení spisových znaků ze souboru
                contentId: "importSpisovyZnak",
                contentCs: "Gordic.Adm.WebControls.ImportAdmSpisovyZnak",
                metadata: this.metadata,
                fields: ["spis_pl", "spis_znak", "nazev", "poznamka", "popis", "skar_znak", "skar_lhuta", "dat_od", "dat_do"],
                columnsResult: ["spis_pl", "spis_znak", "nazev", "popis"],
                dataListDescription: this.dataListDescription,
                addAktivita: true
            })
        }

        closing() {
            this.importDataObj.removeTempFiles();
        }
    }

    export class ImportAdmSpisovyZnakObj extends GBaseAdmImportData<Gordic.AdmIsl.Interface.GAdmSpisovyZnakReadDto> {
        createFinalForm(form: Gordic.Forms.Form): Gordic.Forms.Form {
            form.addRow("jres:32131121").addField("gselectbox", Gordic.Prefabs.Select.sslsspl(), {
                name: "spis_pl",
                model: "model.spis_pl=value.spis_pl",
                validators: [new Gordic.Validators.Required({ stopping: true })],
                flag: "required"
            })
            return form;
        }

        updateDatBeforeSave(formData: any, saveData: any[]): Gordic.AdmIsl.Interface.GAdmSpisovyZnakSaveDto[] {
            saveData = saveData as Gordic.AdmIsl.Interface.GAdmSpisovyZnakSaveDto[];
            for (var i = 0; i < saveData.length; i++) {
                saveData[i]["spis_pl"] = formData["spis_pl"];
                saveData[i]["spis_znak"] = saveData[i]["spis_znak"];
                saveData[i]["dat_od"] = Gordic.Utils.parseDate(saveData[i]["dat_od"]).start;
                saveData[i]["dat_do"] = Gordic.Utils.parseDate(saveData[i]["dat_do"]).start;
                saveData[i]["skar_lhuta"] = (saveData[i]["skar_lhuta"] == null || saveData[i]["skar_lhuta"] == "") ? null : ~~saveData[i]["skar_lhuta"];
                saveData[i]["poznamka"] = saveData[i]["poznamka"];
                saveData[i]["popis"] = saveData[i]["popis"];
            }
            return saveData;
        }


    }
}